import React from 'react'
import { InfoButton } from 'src/components/PageLayout/InfoButton'
import { Tooltip, TooltipOverlayType, TooltipPositions } from './Tooltip'

export const InfoTooltip = ({
  id,
  body,
  placement,
  overlay,
  markdown,
  learnMoreHref,
  noMargin,
  hideArrow,
  compact,
}: {
  id: string
  body?: string
  placement?: TooltipPositions
  overlay?: TooltipOverlayType
  markdown?: string
  learnMoreHref?: string
  noMargin?: boolean
  hideArrow?: boolean
  compact?: boolean
}): JSX.Element => (
  <Tooltip
    id={id}
    placement={placement || TooltipPositions.right}
    overlayType={overlay || TooltipOverlayType.popover}
    tooltipBody={body}
    markdown={markdown}
    learnMoreHref={learnMoreHref}
    hideArrow={hideArrow}
    compact={compact}
  >
    <InfoButton as="span" ml={noMargin ? undefined : 'xs'} />
  </Tooltip>
)
